(function()
{
	var Application = include('springroll.Application');
	var Character = include('nature.Character');
	var Container = include('PIXI.Container');
	var DelayedCall = include('springroll.DelayedCall');
	var Debug = include('springroll.Debug', false);
	var DebugOptions = include('nature.DebugOptions');
	var RandomList = include('springroll.RandomList');
	var WeightedRandom = include('springroll.WeightedRandom');

	var PLAY_AGAIN_TIMEOUT = 8000;
	var _daisy;
	var _squeeks;
	var _activeDelayedCall;
	var _app;

	var _weightedScoreEvents = new WeightedRandom(
	{
		seedFact: 2,
		breezeVO: 2,
		nothing: 6,
	});

	var _playAgainList = new RandomList([
		'playAgainDaisy',
		'playAgainSqueaks',
		'letsFly'
	]);

	var ScoreCharacters = function()
	{
		Container.call(this);

		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		_app = Application.instance;

		_clickHereTimeout = _clickHereTimeout.bind(this);
		_startTimeouts = _startTimeouts.bind(this);

		/**
		 * The MovieClip animation for Daisy
		 * @property {pixiflash.MovieClip} daisy
		 */
		_daisy = mixin(new pixiflash_lib.DaisyArt(), Character);
		_daisy.visible = false;
		this.addChild(_daisy);

		/**
		 * The MovieClip animation for Daisy
		 * @property {pixiflash.MovieClip} daisy
		 */
		_squeeks = mixin(new pixiflash_lib.SqueaksArtClip(), Character);
		_squeeks.x -= 80;
		_squeeks.visible = false;
		this.addChild(_squeeks);
	};

	var p = extend(ScoreCharacters, Container);

	p.show = function(score)
	{
		_daisy.visible = true;

		// show daisy jumping in and then watering
		_app.animator.play(_daisy, [
				'jumpIn',
				{
					anim: 'watering',
					audio: 'Daisy_HereWater'
				}
			],
			this.jumpInComplete.bind(this, score, _app.userHighScore)
		);
		_app.sound.play('DaisyEndHop',
		{
			complete: function()
			{
				_app.sound.play('WaterCan');

			}
		});

		DelayedCall.calls.push(new DelayedCall(function()
		{
			_squeeks.visible = true;
			// enter squeeks
			_app.animator.play(_squeeks, 'SqueeksIn');
		}.bind(this), 1000));
	};

	p.jumpInComplete = function(score)
	{
		_app.sound.play('FlowerGrows');

		// let the user know we had a high score!
		if (DebugOptions.highscore || score == _app.userHighScore)
		{
			if (Math.random() < 0.5)
			{
				_app.animator.play(_daisy, [
				{
					anim: 'highScore2',
					audio: 'Daisy_NewScore'
				}, _startTimeouts]);
			}
			else
			{
				_app.animator.play(_squeeks, [
				{
					anim: 'NotTooShabby',
					audio: 'Squeeks_NotTooShabby'
				}, _startTimeouts]);
			}
		}
		else
		{
			_randomScoreEvent();
		}
	};

	var _randomScoreEvent = function()
	{
		var scoreEvent = _weightedScoreEvents.random();
		// Sometimes we give a factoid about seeds
		if (scoreEvent == 'seedFact')
		{
			var randomFact = [
			{
				anim: 'seedDispersal',
				audio: 'Daisy_SeedsSoar'
			},
			{
				anim: 'seedFact',
				audio: 'Daisy_ManyObstacles'
			}].random();
			_app.animator.play(_daisy, [
				randomFact,
				_startTimeouts
			]);
		}
		// Sometimes a helpful tip about breezes
		else if (scoreEvent == 'breezeVO')
		{
			_app.animator.play(_squeeks,
				{
					anim: 'FlyIntoBreezes',
					audio: 'Squeeks_FlyIntoBreezes'
				},
				_startTimeouts);
		}
		// And sometimes nothing at all :(
		else
		{
			_startTimeouts();
		}
	};

	var _startTimeouts = function()
	{
		DelayedCall.calls.push(new DelayedCall(
			_clickHereTimeout,
			PLAY_AGAIN_TIMEOUT));
	};

	var _clickHereTimeout = function()
	{
		var restartButton = nature.ScoreDisplay.restartButton;
		switch (_playAgainList.random())
		{
			case 'playAgainDaisy':
				_app.animator.play(_daisy, [
					{
						anim: 'PlayAgain',
						audio: 'Daisy_PlayAgain'
					},
					restartButton.wiggle.bind(restartButton, true), (_app.hasTouch ?
					{
						anim: 'TapHere',
						audio: 'Daisy_TapHere'
					} :
					{
						anim: 'ClickHere',
						audio: 'Daisy_ClickHere'
					}),
					restartButton.wiggle.bind(restartButton, false)
				], _startTimeouts);
				break;

			case 'playAgainSqueaks':
				_app.animator.play(_squeeks, [
					{
						anim: 'PlayAgain',
						audio: 'Squeeks_PlayAgain'
					}, restartButton.wiggle.bind(restartButton, true), (_app.hasTouch ?
					{
						anim: 'TapHere',
						audio: 'Squeeks_TapHere'
					} :
					{
						anim: 'ClickHere',
						audio: 'Squeeks_ClickHere'
					}),
					restartButton.wiggle.bind(restartButton, false)
				], _startTimeouts);
				break;

			case 'letsFly':
				// Wait for a timeout
				_app.animator.play(_daisy, [
					{
						anim: 'letsFly',
						audio: 'Daisy_LetsFly'
					},
					restartButton.wiggle.bind(restartButton, true), (_app.hasTouch ?
					{
						anim: 'TapHere',
						audio: 'Daisy_TapHere'
					} :
					{
						anim: 'ClickHere',
						audio: 'Daisy_ClickHere'
					}),
					restartButton.wiggle.bind(restartButton, false)
				], _startTimeouts);
				break;
		}
	};

	/**
	 * When the state starts exiting
	 * @method exitStart
	 */
	p.exitStart = function()
	{
		_app.animator.stop(_daisy);
		_app.animator.stop(_squeeks);
	};

	/**
	 * destroy and don't use after this
	 * @method destroy
	 */
	p.destroy = function()
	{
		this.removeChildren();

		_daisy.destroy(true);
		_squeeks.destroy(true);

		if (_activeDelayedCall)
		{
			_activeDelayedCall.destroy();
		}
		_activeDelayedCall = null;
	};

	namespace('nature').ScoreCharacters = ScoreCharacters;

}());
